import {Accordion} from "@szhsin/react-accordion";
import type {SectionAccordions} from "@/generated/api";
import SectionWrapper from "@/layouts/SectionWrapper";
import {AccordionContent, AccordionHeader, AccordionItem} from "./AccordionItem";
import {SectionContentWrapper} from "./styles";

interface B7AccordionProps {
  sectionData: SectionAccordions;
  isFirstSection?: boolean;
  isLastSection?: boolean;
  id?: string;
}

export default function B7Accordion({
  sectionData,
  isFirstSection,
  isLastSection,
  id,
}: B7AccordionProps) {
  const {open_behaviour, bg_color, accordions} = sectionData;

  return (
    <SectionWrapper
      id={id}
      backgroundColor={bg_color}
      isFirstSection={isFirstSection}
      isLastSection={isLastSection}
    >
      <SectionContentWrapper>
        <div style={{borderTop: "1px solid #ccc"}}>
          <Accordion
            allowMultiple={open_behaviour === "1"}
            transition
            transitionTimeout={250}
          >
            {accordions?.map((item) => {
              return (
                <AccordionItem
                  key={item.text}
                  header={<AccordionHeader emoji={item.emoji} title={item.title} />}
                >
                  <AccordionContent content={item.text} />
                </AccordionItem>
              );
            })}
          </Accordion>
        </div>
      </SectionContentWrapper>
    </SectionWrapper>
  );
}
